import { FC, memo, useCallback, useState } from 'react';
import { avnuLiquiditySourcesAtom } from '../../../atoms';
import Typography from '../Typography';
import ModalWrapper from '../ModalWrapper';
import Icon from '../Icon';
import ButtonTertiary from '../ButtonTertiary';
import SwapSourceItem from './SwapSourceItem';

import './SwapSettings.scss';
import { useAtom } from '../../../lib';

const SwapSettingsComponent: FC = () => {
  const [avnuLiquiditySources] = useAtom(avnuLiquiditySourcesAtom);

  const [open, setOpen] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  return (
    <>
      <ButtonTertiary onClick={handleOpen}>
        <Icon variant="settings" color="--icon-supporting" size={14} />
      </ButtonTertiary>
      <ModalWrapper open={open} onClose={handleClose}>
        <div className="nostra__swapSettings__modal">
          <Typography variant="heading-sm" weight="medium">
            AVNU liquidity sources
          </Typography>

          <div className="nostra__swapSettings__liquiditySources">
            {avnuLiquiditySources.map(source => {
              return <SwapSourceItem key={source.name} name={source.name} />;
            })}
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};
export const SwapSettings = memo(SwapSettingsComponent);
